var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('input',{staticClass:"simple-checkbox",class:_vm.checked,attrs:{"type":"checkbox","id":"checkboxID","disabled":_vm.disabled},domProps:{"checked":_vm.value}}),_c('label',{attrs:{"for":"checkboxID"},on:{"click":function($event){return _vm.onChange($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }